import React from 'react';
import { TimePicker as AntTimePicker } from 'antd';
import { TimeRangePickerProps } from 'antd/lib/time-picker';

import cn from 'classnames';
import styles from './TimePicker.module.scss';

const defaultFormat = 'h:mm:A';

/**
 * RangePicker component
 */
export const RangePicker: React.FC<TimeRangePickerProps> = ({
  className,
  ...props
}) => (
  <AntTimePicker.RangePicker
    className={cn(styles.TimePicker, className)}
    format={defaultFormat}
    {...props}
  />
);
